module.exports = __webpack_public_path__ + "static/media/headerbg.27c2ab6a.jpg";